import type { CreateFavouriteRequest } from "src/core/backend/clients/backendClient";
import { backendService } from "../../../core/backend/services/backendService";

class FavouriteService {
  public favouriteList() {
    return backendService.createBackendClient().apiFavouriteGet();
  }

  public favouriteDelete(id: number) {
    return backendService.createBackendClient().apiFavouriteDelete(id);
  }

  public favouritePost(request: CreateFavouriteRequest) {
    return backendService.createBackendClient().apiFavouritePost(request);
  }
}

export const favouriteService = new FavouriteService();
